/* src/js/dropdown-box.js */

import $ from 'jquery';

let $body = $('body');

function closeDropDownBox() {
    $('.dropdown-box').removeClass('dropdown-box-open');
    $('.js-dropdown-box-target').fadeOut('fast');

}

$body.on('click', '.js-dropdown-box-trigger', function (e) {
    e.preventDefault();

    let $trigger = $(this);
    let $context = $trigger.closest('.dropdown-box');
    let $target = $context.find('.js-dropdown-box-target');


    if ($context.hasClass('dropdown-box-open')) {
        closeDropDownBox();
    } else {
        closeDropDownBox();
        $context.addClass('dropdown-box-open');
        $target.fadeIn('fast');
    }

});

$body.on('click', '.js-dropdown-close', function(e) {
    e.preventDefault();
    closeDropDownBox();
});

$(document).mouseup(function (e) {
    let container = $('.dropdown-box');

    if (!container.is(e.target)
        && container.has(e.target).length === 0) {
        closeDropDownBox();
    }
});












